import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import CtaButton from '../buttons/cta-button'
import FlatButton from '../buttons/flat-button'

const ConfirmationMsg = props => {
  return (
    <div
      className={classNames({
        'confirmation-msg': true,
        [props.className]: props.className
      })}
    >
      {props.children}
      {props.hasActions ? (
        <div className='msg-actions'>
          {props.FlatButton ? (
            <FlatButton text={props.flatText} onClick={props.onCancel} />
          ) : null}
          {props.CtaButton ? (
            <CtaButton
              text={props.ctaText}
              hasIcon={props.hasIcon}
              iconName={props.iconName}
              onClick={props.onAccept}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

ConfirmationMsg.propTypes = {
  FlatButton: PropTypes.bool,
  flatText: PropTypes.string,
  ctaText: PropTypes.string,
  iconName: PropTypes.string,
  CtaButton: PropTypes.bool,
  hasActions: PropTypes.bool,
  hasIcon: PropTypes.bool,
  onCancel: PropTypes.func,
  onAccept: PropTypes.func
}

export default ConfirmationMsg



// WEBPACK FOOTER //
// ./src/ui/messages/confirmation-msg.js